import { Anchor, Box, Image } from '@mantine/core';

// 狭いヘッダーは開閉・現在地・アカウントで埋まるので、ブランドはナビの最上部に出す
export function NavbarBrand() {
  return (
    <Box hiddenFrom="md" mb="md">
      <Anchor href="/">
        <Image src="/plm_a_full_rgb.png" w={100} h={32} alt="plamo" />
      </Anchor>
    </Box>
  );
}
